// src/services/GetUserInfoFornecedor.js
import {jwtDecode} from 'jwt-decode';

export function getUserInfoFornecedor() {
    const token = localStorage.getItem('token-fornecedor');
    if (!token) return {};
    const decoded = jwtDecode(token);
    const [cod_cli, loj_cli] = decoded.user_code.split(';');
    return {
        cnpj_empresa: decoded.cnpj,
        cod_cli: cod_cli,
        loj_cli: loj_cli,
        user_id: decoded.userId,
    };
}
